import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import vip from './modules/vip'
import enterprise from './modules/enterprise'
import dictionary from './modules/dictionary'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		user,
		vip,
		enterprise,
		dictionary
	},
	getters
})
